import { Box, Button } from "@saleor/macaw-ui/next";
import React from "react";
import { useIntl } from "react-intl";

interface ProductVariantSetDefaultProps {
  onSetDefaultVariant: () => void;
}

const ProductVariantSetDefault: React.FC<ProductVariantSetDefaultProps> = ({
  onSetDefaultVariant,
}) => {
  const intl = useIntl();

  const IS_READONLY = process.env.PRODUCT_EDIT_DISABLE_DEV_FLAG === "true" ? true : false;

  return (
    <Box display="flex" alignItems="center" height="100%">
      <Button
        variant="secondary"
        onClick={onSetDefaultVariant}
        data-test-id="setDefault"
        disabled={IS_READONLY} // disables product variant set default button
      >
        {intl.formatMessage({
          id: "SZH0fw",
          defaultMessage: "Set as default",
          description: "set variant as default, button",
        })}
      </Button>
    </Box>
  );
};

ProductVariantSetDefault.displayName = "ProductVariantSetDefault";
export default ProductVariantSetDefault;
